import { useEffect, useState } from 'react';
import { authService } from '@/core/auth/export';
import { useEffectivePermissions } from '@/core/permissions/hooks/use-effective-permissions';

export function useHasPermission(allow: string | RegExp): boolean {
  const isTestEnv = process.env.REACT_APP_TEST_ENV === 'true';
  const [ready, setReady] = useState(isTestEnv);
  const permissions = useEffectivePermissions();

  useEffect(() => {
    if (isTestEnv) return;

    authService.onTokenAvailable().then(() => setReady(true));
  }, [isTestEnv]);

  if (isTestEnv) return true;

  if (!ready) return false;

  return permissions.reduce((accumulator, value) => {
    if (allow instanceof RegExp) {
      return allow.test(value) || accumulator;
    }

    return allow === value || accumulator;
  }, false);
}
